import { render, staticRenderFns } from "./settlement-purchase-summary-detail.vue?vue&type=template&id=47ba48c4&scoped=true"
import script from "./settlement-purchase-summary-detail.vue?vue&type=script&lang=js"
export * from "./settlement-purchase-summary-detail.vue?vue&type=script&lang=js"
import style0 from "./settlement-purchase-summary-detail.vue?vue&type=style&index=0&id=47ba48c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ba48c4",
  null
  
)

export default component.exports